module.exports = __webpack_public_path__ + "static/img/p2.75a4296.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/p2.png
// module id = GAox
// module chunks = 1